import React from "react";
import PropTypes from "prop-types";
import { MUIDurationPicker } from "../../../durationPicker/durationPicker";
import { VESSEL_TYPE } from "../../../../constants/constants";

export const TrendComponentSettings = (props) => {
  const { vessel, startDate, setStartDate, endDate, setEndDate } = props;

  return (
    <MUIDurationPicker
      isSEPVessel={vessel?.vesselType === VESSEL_TYPE.SEP}
      startDate={startDate}
      setStartDate={setStartDate}
      endDate={endDate}
      setEndDate={setEndDate}
    />
  );
};

TrendComponentSettings.propTypes = {
  vessel: PropTypes.object,
  startDate: PropTypes.object,
  setStartDate: PropTypes.func,
  endDate: PropTypes.object,
  setEndDate: PropTypes.func,
};
